// 智能引导 bot:smartguide，后续AI数字员工 bot:mpush
const isBot = privilege => ['bot', 'bot:smartguide', 'bot:mpush', 'bot:ex'].includes(privilege);

export default isBot;
